import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { ProductListComponent } from './modules/product/pages/product-list/product-list.component';
import { AdminGuard } from './core/guards/admin.guard';
import { AuthenticationGuard } from './core/guards/authentication.guard';


const routes: Routes = [
  //{
  //  path: "",
  //  redirectTo: "/product",
  //  pathMatch: "full"
  //},
  {
    path: "auth",
    component: PublicLayoutComponent,
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: "",
    component: PublicLayoutComponent,
    children: [
      {
        path: "",
        component: ProductListComponent
        // loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule),
      },
      {
        path: "orders",
        loadChildren: () => import('./modules/order/order.module').then(m => m.OrderModule),
      },
      {
        path: "quotes",
        loadChildren: () => import('./modules/quote/quote.module').then(m => m.QuoteModule),
      },
      {
        path: "product",
        loadChildren: () => import('./modules/product/product.module').then(m => m.ProductModule),
      },
      {
        path: "dealer",
        loadChildren: () => import('./modules/dealer/dealer.module').then(m => m.DealerModule),
      },      
      {
        path: "favorites",
        loadChildren: () => import('./modules/favorites/favorites.module').then(m => m.FavoritesModule)
      }
    ]
  },
  {
    path: "admin",
    canActivate: [AdminGuard],
    component: AdminLayoutComponent,
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
  },
  // Fallback when no prior routes is matched
  {
    path: "**",
    redirectTo: "/product",
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
